import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import history from '../../history';
import SubHeader from './SubHeader';

class ManageRelease extends React.Component {
    componentDidMount() {
        if (!this.props.isAuthen) {
            history.push(`/home/${this.props.match.params.userId}`)
        }
    }

    render() {
        return (
            <div className="flex-v home">
                <div className="flex-v flex-1">
                    <SubHeader text="Manage Release" />
                    <div className="mr-24 ml-24 mt-8 mb-8">
                        {this.props.bookReleaseList.length === 0 ?
                            <div className="card not-found has-text-danger">Not Found</div> :
                            <div>
                                <div className="grid-book-release-list m-24">
                                    <div className="has-text-grey-light is-italic">
                                        Release Version
                                </div>
                                    <div className="has-text-grey-light is-italic">
                                        Valid From
                                </div>
                                    <div className="has-text-grey-light is-italic">
                                        Valid To
                                </div>
                                    <div className="has-text-grey-light is-italic">
                                        Created Date
                                </div>
                                    <div className="has-text-grey-light is-italic">
                                        Modified Date
                                </div>
                                    <div className="has-text-grey-light is-italic">
                                        Status
                                </div>
                                </div>
                                {this.props.bookReleaseList.map((ele, i) => {
                                    return (
                                        <div onClick={() => { }} key={i} className="bb grid-book-release-list pt-16 pb-16 mr-24 ml-24 pointer">
                                            <div>{ele.BookReleaseVersion}</div>
                                            <div>{moment(ele.ValidFrom).format('DD/MM/YYYY')}</div>
                                            <div>{moment(ele.ValidTo).format('DD/MM/YYYY')}</div>
                                            <div>{moment(ele.CreatedDate).format('DD/MM/YYYY')}</div>
                                            <div>{moment(ele.ModifiedDate).format('DD/MM/YYYY')}</div>
                                            <div>{this.props.selectedBookRelease.BookReleaseVersion === ele.BookReleaseVersion && <span style={{ color: 'green' }}>Current</span>}</div>
                                        </div>
                                    );
                                })}
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        bookReleaseList: state.doa.bookReleaseList,
        isAuthen: state.auth.isAuthen,
        selectedBookRelease: state.doa.selectedBookRelease
    }
}

export default connect(mapStateToProps)(ManageRelease)